import { Trans } from "@lingui/macro";
import type { Currency } from "@src/__generated__/graphql";
import { currency as currencyFormatter, dateTime } from "@src/utils/formatters";
import { lowerCase, upperFirst } from "lodash";

interface PaidCellProps {
  paid?: number | null;
  currency?: Pick<Currency, "code" | "denomination"> | null;
  paymentStatus?: string | null;
}

export const PaidCell = ({ paid, currency, paymentStatus }: PaidCellProps) => {
  if (paid != null && currency) {
    return currencyFormatter.formatByCurrency(paid, currency);
  }

  if (paymentStatus != null) {
    return upperFirst(lowerCase(paymentStatus.replaceAll("_", " ")));
  }

  return null;
};

interface PaidAtCellProps {
  paidAt?: string | Date | null;
  hasPayment?: boolean | null;
}

export const PaidAtCell = ({ paidAt, hasPayment }: PaidAtCellProps) => {
  if (paidAt) {
    return <>{dateTime.format(new Date(paidAt))}</>;
  }

  if (hasPayment) {
    return <Trans>Partially paid</Trans>;
  }

  return <Trans>Unpaid</Trans>;
};
